if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
         if($('.product-form__input input').is(':checked')) {
                 this.submitButton.setAttribute('aria-disabled', true);
                 this.submitButton.classList.add('loading');
                 this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

          $('.sizeErrorMessage').remove();
          const havePopup_Size = document.querySelector('.size_popup');
          if(havePopup_Size) {
           havePopup_Size.classList.remove('active'); 
          }
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
         }else {
           
          if($('.sizeErrorMessage').length < 1) {
            const window_w = window.innerWidth;
            if(window_w > 768) {
               $('html, body').animate({
                  scrollTop: $(".variantPickrSec").offset().top
              }, 1000);
              $('.variantPickrSec fieldset').prepend('<div id="sizeErrorMessage" class="sizeErrorMessage" style="color: red; font-weight: bolder;, font-size: 2rem;">Please Select Size</div>');  
            }else {
              
              const container = document.querySelector('.variantPickrSec');
              if(container) {
                const getInputVal = container.querySelectorAll('input[type="radio"]');
                var inserthtml = document.querySelector('.popup_sizes_wrap');
                if (!inserthtml.closest('.size_popup').classList.contains('active')) {
                  getInputVal.forEach((value) => {
                    inserthtml.insertAdjacentHTML('beforeend', `<label class="popup_size_label" data-value="${value.value}">${value.value}</label>`);
                  });
                  inserthtml.closest('.size_popup').classList.add('active');
                  
                  const popup_sizeClick = document.querySelectorAll('.popup_size_label');
                  popup_sizeClick.forEach((size_label) => {
                    size_label.addEventListener('click', (event) => {
                      const currentlyActive = document.querySelector('.popup_size_label.active_label');
                      if (currentlyActive) {
                        currentlyActive.classList.remove('active_label');
                      }
                      event.currentTarget.classList.add('active_label');
                      const getInputVal = event.target.getAttribute('data-value');
                      container.querySelector(`input[value="${getInputVal}"]`).click(); 
                    });
                  });
                }
              }
              const overlay_click = document.querySelector('.size_overlay_layer');
              if(overlay_click) {
                overlay_click.addEventListener('click', (event) => {
                  document.querySelector('.size_popup').classList.remove('active');
                  document.querySelectorAll('.popup_size_label').forEach(el => el.remove());
                });
              }
              
              const size_click = document.querySelector('.popup_sizes_title .open_size');
              if(size_click) {
                size_click.addEventListener('click', (event) => {
                  document.querySelector('[data-fancybox].size-guide-text').click();
                });
              }
            }
          }
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
